import { BoltIcon, ChevronRightIcon, ClipboardIcon, HeartIcon, LifebuoyIcon, MegaphoneIcon, UsersIcon } from "@heroicons/react/24/outline";
import { CompanyResource, HeroIcon } from "../types";
import colors from "tailwindcss/colors";

function generateIcon(resourceName: string): { icon: HeroIcon; color: string; backgroundColor: string } {
  const lowercase = resourceName.toLowerCase();
  if (lowercase.includes("crisis")) {
    return { icon: LifebuoyIcon, color: colors.red[600], backgroundColor: colors.red[50] };
  }
  if (lowercase.includes("resource")) {
    return { icon: MegaphoneIcon, color: colors.fuchsia[600], backgroundColor: colors.fuchsia[50] };
  }
  if (lowercase.includes("support")) {
    return { icon: HeartIcon, color: colors.green[600], backgroundColor: colors.green[50] };
  }
  if (lowercase.includes("benefit")) {
    return { icon: ClipboardIcon, color: colors.purple[600], backgroundColor: colors.purple[50] };
  }
  if (lowercase.includes("wellness")) {
    return { icon: BoltIcon, color: colors.yellow[600], backgroundColor: colors.yellow[50] };
  } else {
    return { icon: UsersIcon, color: colors.blue[600], backgroundColor: colors.blue[50] };
  }
}

function formatLink(url: string): string {
  if (!/^https?:\/\//i.test(url)) {
    return `http://${url}`;
  }
  return url;
}

export default function CompanyResourceCard(props: { resource: CompanyResource }) {
  const { resource } = props;

  const icon = generateIcon(resource.company_resource_name);

  return (
    <div className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start gap-4">
        <div className="p-2 rounded-lg" style={{ backgroundColor: icon.backgroundColor }}>
          <icon.icon className="size-6" style={{ color: icon.color }} />
        </div>
        <div>
          <h3 className="font-semibold text-gray-900 mb-1">{resource.company_resource_name}</h3>
          <p className="text-sm text-gray-600 mb-3">{resource.company_resource_description}</p>
          {resource.email && (
            <div>
              <a href={`mailto:${resource.email}`} className="text-blue-600 hover:text-blue-700 text-sm font-medium">
                {resource.email}
              </a>
            </div>
          )}
          {resource.phone && (
            <div>
              <a href={`tel:${resource.phone}`} className="text-blue-600 hover:text-blue-700 text-sm font-medium">
                {resource.phone}
              </a>
            </div>
          )}
          {resource.link && (
            <div>
              <a href={`${formatLink(resource.link)}`} target="_blank" className="text-blue-600 hover:text-blue-700 text-sm font-medium">
                {resource.link_text ? (
                  <span className="flex items-center">
                    {resource.link_text}
                    <ChevronRightIcon className="size-3" />
                  </span>
                ) : (
                  resource.link
                )}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
